import { motion } from "framer-motion";
import { PILOT_OBJECTIVES } from "@/data/content";

export const PilotObjectives = () => (
  <section data-testid="pilot-objectives-section" className="bg-baseLight px-6 pt-[10px] pb-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:max-w-none lg:text-center">
        <h2
          data-testid="pilot-objectives-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
        >
          Understanding real operating needs
        </h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-x-16 gap-y-10 sm:grid-cols-2 lg:mt-12">
        {PILOT_OBJECTIVES.map((objective, i) => (
          <motion.div
            key={objective.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`pilot-objective-${i}`}
            className="border-t-2 border-teal/20 pt-6"
          >
            <h3 className="font-heading text-lg font-semibold text-ink">{objective.title}</h3>
            {objective.title === "Renewable Integration" ? (
              <p className="mt-2 text-[15px] leading-relaxed text-inkSoft">
                Evaluate opportunities to combine available renewable generation with
                <br className="hidden lg:block" /> energy storage.
              </p>
            ) : (
              <p className="mt-2 text-[15px] leading-relaxed text-inkSoft">{objective.body}</p>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
